/**
 * 应用中心电商系统模块
 */
export const ApplyMallArr = [
  {
    path: "mallManagement",
    name: "mallManagement",
    meta: {
      title: "分类"
    },
    redirect: "/apply/mallManagement/mall/manage",
    component: () => import("@/views/apply/comModule/mallManagement.vue"),
    children: [
      {
        path: "mall",
        name: "mall",
        meta: {
          title: "商品库"
        },
        redirect: "/apply/mallManagement/mall/manage",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "manage",
            name: "manage",
            meta: {
              title: "商品管理"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/manage.vue")
          },
          {
            path: "screen",
            name: "screen",
            meta: {
              title: "筛选项管理"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/screen.vue")
          },
          {
            path: "newGoodsSort",
            name: "newGoodsSort",
            meta: {
              title: "商品分类1"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/newGoodsSort.vue")
          },
          {
            path: "commodityLabel",
            name: "commodityLabel",
            meta: {
              title: "商品标签"
            },
            component: () =>
              import(
                "@/views/apply/comModule/mall/commodity/commodityLabel.vue"
              )
          },
          {
            path: "commodityServe",
            name: "commodityServe",
            meta: {
              title: "商品服务"
            },
            component: () =>
              import(
                "@/views/apply/comModule/mall/commodity/commodityServe.vue"
              )
          },
          {
            path: "Group",
            name: "Group",
            meta: {
              title: "商品分组"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/Group.vue")
          },
          {
            path: "Brand",
            name: "Brand",
            meta: {
              title: "商品品牌"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/Brand.vue")
          },
          {
            path: "Attribute",
            name: "Attribute",
            meta: {
              title: "商品属性"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/Attribute.vue")
          },
          {
            path: "Parameter",
            name: "Parameter",
            meta: {
              title: "商品参数"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/Parameter.vue")
          },
          {
            path: "comType",
            name: "comType",
            meta: {
              title: "商品类型"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/comType.vue")
          },
          {
            path: "editorProduct",
            name: "editorProduct",
            meta: {
              title: "编辑商品"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/editorProduct")
          },
          {
            path: "addProduct",
            name: "edit",
            meta: {
              title: "添加商品"
            },
            component: () =>
              import(
                "@/views/apply/comModule/mall/commodity/addProduct/index.vue"
              )
          },
          {
            path: "choseClassify",
            name: "edit",
            meta: {
              title: "选择分类"
            },
            component: () =>
              import("@/views/apply/comModule/mall/commodity/choseClassify")
          }
        ]
      },
      {
        path: "order",
        name: "order",
        meta: {
          title: "订单"
        },
        redirect: "/apply/mallManagement/order/allOrder",
        component: {
          render: c => c("router-view")
        },
        children: [
          // 订单
          {
            path: "allOrder",
            name: "allOrder",
            meta: {
              title: "全部订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/allOrder.vue")
          },
          {
            path: "orderDetails",
            name: "orderDetails",
            meta: {
              title: "订单详情"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/orderDetails.vue")
          },
          {
            path: "dfhOrder",
            name: "dfhOrder",
            meta: {
              title: "待发货订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/dfhOrder.vue")
          },
          {
            path: "dfkOrder",
            name: "dfkOrder",
            meta: {
              title: "待付款订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/dfkOrder.vue")
          },
          {
            path: "ywcOrder",
            name: "ywcOrder",
            meta: {
              title: "已完成订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/ywcOrder.vue")
          },
          {
            path: "ygbOrder",
            name: "ygbOrder",
            meta: {
              title: "已关闭订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/ygbOrder.vue")
          },
          {
            path: "orderTools",
            name: "orderTools",
            meta: {
              title: "已关闭订单"
            },
            component: () =>
              import("@/views/apply/comModule/mall/order/orderTools.vue")
          }
        ]
      },
      // 系统管理
      {
        path: "system",
        name: "system",
        meta: {
          title: "系统管理"
        },
        redirect: "/apply/mallManagement/system/home",
        component: {
          render: c => c("router-view")
        },
        children: [
          {
            path: "home",
            name: "home",
            meta: {
              title: "首页"
            },
            redirect: "/apply/mallManagement/system/home/advertising",
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "advertising",
                name: "advertising",
                meta: {
                  title: "广告"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/home/advertising.vue"
                  )
              },
              {
                path: "navigation",
                name: "navigation",
                meta: {
                  title: "导航"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/home/navigation.vue"
                  )
              }
            ]
          },
          {
            path: "shopMall",
            name: "shopMall",
            meta: {
              title: "商城"
            },
            redirect: "/apply/mallManagement/system/shopMall/notice",
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "notice",
                name: "notice",
                meta: {
                  title: "公告管理"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/notice.vue"
                  )
              },
              {
                path: "addnotice",
                name: "notice",
                meta: {
                  title: "添加公告"
                },
                component: () => import("@/components/system/addNotice.vue")
              },
              {
                path: "editnotice",
                name: "notice",
                meta: {
                  title: "编辑公告"
                },
                component: () =>
                  import("@/components/commodity/editAnnouncement.vue")
              },
              {
                path: "comment",
                name: "comment",
                meta: {
                  title: "评论管理"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/comment.vue"
                  )
              },
              {
                path: "addComment",
                name: "addComment",
                meta: {
                  title: "添加虚拟评论"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/addComment.vue"
                  )
              },
              {
                path: "backAddress",
                name: "backAddress",
                meta: {
                  title: "退货地址"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/backAddress.vue"
                  )
              },
              {
                path: "addBackAddress",
                name: "addBackAddress",
                meta: {
                  title: "编辑退货地址"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/addBackAddress.vue"
                  )
              },
              {
                path: "rank",
                name: "rank",
                meta: {
                  title: "排行榜设置"
                },
                component: () =>
                  import(
                    "@/views/apply/comModule/mall/system/shopMall/rank.vue"
                  )
              }
            ]
          },
          {
            path: "distribution",
            name: "distribution",
            meta: {
              title: "配送方式"
            },
            component: {
              render: c => c("router-view")
            },
            children: [
              {
                path: "expressage",
                name: "expressage",
                meta: {
                  title: "快递配送"
                },
                component: {
                  render: c => c("router-view")
                },
                children: [
                  // 快递
                  {
                    path: "freight_",
                    name: "freight_",
                    meta: {
                      title: "添加运费模板"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/mall/system/distribution/expressage/freight_.vue"
                      )
                  },
                  {
                    path: "waybill",
                    name: "waybill",
                    meta: {
                      title: "快递配送"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/mall/system/distribution/expressage/waybill.vue"
                      )
                  },
                  {
                    path: "peisongset",
                    name: "peisongset",
                    meta: {
                      title: "添加配送方式"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/mall/system/distribution/expressage/peisongset.vue"
                      )
                  },
                  {
                    path: "fedex",
                    name: "fedex",
                    meta: {
                      title: "快递运单"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/mall/system/distribution/expressage/fedex.vue"
                      )
                  },
                  {
                    path: "freightSet",
                    name: "freightSet",
                    meta: {
                      title: "快递设置"
                    },
                    component: () =>
                      import(
                        "@/views/apply/comModule/mall/system/distribution/expressage/freightSet.vue"
                      )
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
